import React, { useState, useEffect } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import AdminHeader from "./AdminHeader";
import "./AdminBilling.css";
import { Table, Tag } from "antd";
import { AdminDashboardAPI, AdminDashboardCountAPI } from "../API/Api";
import axios from "axios";
import logo1 from '../../Assets/milklogo.jpg'

const AdminDashboard = () => {
  const [columns, setColumns] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  const [dashboardData, setDashboardData] = useState(null);
  const userdata = JSON.parse(sessionStorage.getItem('userdata'));
  const branchId = userdata.branch_id;

  useEffect(() => {
    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener('popstate', function (event) {
        window.history.pushState(null, document.title, window.location.href);
    });

    return () => {
        window.removeEventListener('popstate', function (event) {
            window.history.pushState(null, document.title, window.location.href);
        });
    };
}, []);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const obj = {
          branch_id: branchId,
        };

        const response = await axios.post(AdminDashboardAPI, obj);
        console.log("api...", response.data);
        const list = response.data || [];
        const firstObject = list[0] || {};
        const cols = [];
        for (const key in firstObject) {
          var render = (value) => {
            return <span>{String(value)}</span>;
          };
          if (typeof firstObject[key] === "object") {
            if (Array.isArray(firstObject[key])) {
              render = (value) => {
                return (
                  <span>
                    {value.map((tag) => {
                      return <Tag key={tag}>{tag}</Tag>;
                    })}
                  </span>
                );
              };
            } else {
              render = (value) => {
                return (
                  <span>
                    {Object.keys(value).map((innerKey) => {
                      return (
                        <div key={innerKey}>
                          {innerKey} : {value[innerKey]}
                        </div>
                      );
                    })}
                  </span>
                );
              };
            }
          }

          const col = {
            title: String(key).charAt(0).toUpperCase() + String(key).slice(1),
            dataIndex: key,
            render: render,
          };
          cols.push(col);
        }

         // Calculate totals for each column
         const totals = {};
         list.forEach((item) => {
           for (const key in item) {
             if (key !== "EmployeeName" ) {
               totals[key] = (totals[key] || 0) + parseInt(item[key]);
             }
           }
         });
 
         // Add totals to the last row
         const totalRow = { ...totals, EmployeeName: "Total"};
         list.push(totalRow);

        // Add the total column
        const totalCol = {
          title: "Total",
          dataIndex: "total",
          render: (value) => <span>{value}</span>,
        };
        cols.push(totalCol);

        setColumns(cols);

        // Calculate totals for each row and add the total value as a property to each row object
        const updatedList = list.map((item) => {
          let total = 0;
          for (const key in item) {
            if (key !== "EmployeeName" ) {
              total += parseInt(item[key]);
            }
          }
          return { ...item, total };
        });

        // Update dataSource state
        setDataSource(updatedList);
      } catch (error) {
        console.error("Error fetching data:", error);
        // Handle errors
      }
    };

    fetchData();
  }, []);

  // ============== count API =====================



  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(AdminDashboardCountAPI, {
          branch_id: branchId
        });
  
        console.log("api...e", response.data);
  
        const data = response.data;
        setDashboardData(data);
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
      }
    };
  
    fetchData();
  }, []); // Empty dependency array means this effect will run once after the initial render


  return (
    <Container fluid style={{ backgroundColor: "rgb(214, 234, 248)" }}>
      <Row>
        <AdminHeader />
      </Row>


      <Row className=" pt-5">
        <Col
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "#800000",
          }}
        >
          <h4>
            <b>DASHBOARD</b>
          </h4>
        </Col>
      </Row>

<Row className="mx-md-5 px-md-5">
      <Row md={3} sm={1} className='g-4 m-0 p-0 mt-2 px-md-5' style={{ display: "flex", justifyContent: "center" }}>
      <Col>
        <Card className='cloudImg'>
          <Card.Body className='text-center'>
            <Card.Text><h3 style={{color:"#191970"}}>{dashboardData && dashboardData.paymentpendingamount}</h3></Card.Text>
            <Card.Title>Payment Pending Amount</Card.Title>
          </Card.Body>
        </Card> 
      </Col>
      <Col>
        <Card className='cloudImg1'>
          <Card.Body className='text-center'>
            <Card.Text><h3 style={{color:"#191970"}}>{dashboardData && dashboardData.todaystotalpaymentamount}</h3></Card.Text>
            <Card.Title>Today Receive Amount</Card.Title>
          </Card.Body>
        </Card>
      </Col>
    </Row>

      <Row md={3} sm={1} className='g-4 m-0 p-0 mt-2 px-md-5'>
      <Col>
        <Card className='cloudImg2'>
          <Card.Body className='text-center'>
          <Card.Text><h3 style={{color:"#191970"}}>{dashboardData && dashboardData.Productdeliverycount}</h3></Card.Text>
            <Card.Title>Product Delivery Count</Card.Title>
          </Card.Body>
        </Card>
      </Col>
      <Col>
        <Card className='cloudImg3'>
          <Card.Body className='text-center'>
          <Card.Text><h3 style={{color:"#191970"}}>{dashboardData && dashboardData.dailystockcount}</h3></Card.Text>
            <Card.Title >Daily Stock Count</Card.Title>
          </Card.Body>
        </Card>
      </Col>
      <Col>
        <Card className='cloudImg4'>
          <Card.Body className='text-center'>
          <Card.Text><h3 style={{color:"#191970"}}>{dashboardData && dashboardData.pendingbag}</h3></Card.Text>
            <Card.Title>Product Pending Count</Card.Title>
          </Card.Body>
        </Card>
      </Col>
      
    </Row>
</Row>

<Row className="mx-md-5 px-md-5">
      <div style={{ overflowY: 'auto' }}>
        <div style={{ overflowX: 'auto' }}>
          <div className="mt-5 ant-table-wrapper" style={{ marginBottom: "80px", maxHeight: "800px", border: "1px solid #e0e0e0", borderRadius: "10px" }}>
            <Table className="custom-table" columns={columns} dataSource={dataSource} pagination={{ position: ['bottomCenter'] }} />
          </div>
        </div>
      </div>
    </Row>
    </Container>
  );
};

export default AdminDashboard;
